module.exports = __webpack_public_path__ + "img/69_25.ff238991.png";